import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-flathub',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Flathub icon</title><path d="M12 2.604l-.43.283L0 10.459v6.752l6.393 4.184L12 17.725l5.607 3.671L24 17.211v-6.752L12 2.604zm0 .828l5.434 3.556-2.717 1.778L12 10.545l-2.717-1.78-2.717-1.777L12 3.432zM6.39 7.104l5.434 3.556-5.408 3.54-5.434-3.557 5.409-3.54zm11.22 0l5.431 3.554-5.434 3.557-5.433-3.555 5.435-3.556zM.925 10.867l5.379 3.52a.123.08 0 00.027.013v5.647l-5.406-3.54v-5.64zm11.213.115l5.408 3.54v5.664l-5.408-3.54v-5.664z"/></svg>`,
    styles: []
})
export class SimpleIconsFlathubComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#4A86CF';
    @Input() className: string = 'simple-icons-flathub'
    constructor() {}
    ngOnInit(): void {}
}
